import { GF_FieldError, GF_Section } from '../../../model/gforms/gform';
import { SanitizeHTML } from '../../globals/SanitizeHTML';

interface Props {
  field: GF_Section;
  fieldErrors: GF_FieldError[];
}

export default function SectionField({ field, fieldErrors }: Props) {
  const { type, visibility, label, description } = field;

  return (
    <div
      className={`gfield gfield-${type} relative mt-10 mb-8 px-3 py-5 rounded-2xl bg-primary !bg-opacity-10 ${
        visibility === 'hidden' ? 'hidden' : ''
      }`.trim()}
    >
      <h3
        className={`font-bold text-md text-center text-primary ${
          description && 'mb-1'
        }`}
      >
        {label}
      </h3>
      <p className="text-sm text-center">
        <SanitizeHTML html={description?.replaceAll('\n', '<br/>')} />
      </p>
    </div>
  );
}
